import { render, staticRenderFns } from "./ViewDocumentPdf.vue?vue&type=template&id=457de8fd&scoped=true"
import script from "./ViewDocumentPdf.vue?vue&type=script&lang=js"
export * from "./ViewDocumentPdf.vue?vue&type=script&lang=js"
import style0 from "./ViewDocumentPdf.vue?vue&type=style&index=0&id=457de8fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457de8fd",
  null
  
)

export default component.exports